
import Vue from "vue";
import CatIcon from "@/components/atoms/CatIcon.vue";
import CatNicknameDialogBase from "@/components/ui/CatNicknameDialogBase.vue";
import { AssistantCat } from "@/lib/models/assistantCat";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    CatIcon,
    CatNicknameDialogBase,
  },

  props: {
    assistantCat: {
      type: Object as () => AssistantCat | null,
      default: null,
    },
    nickname: {
      type: String,
      required: true,
    },
    isResettingToDefault: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onClose() {
      this.$emit("close");
    },

    onConfirm() {
      this.$emit("confirm");
    },

    onClickOutside() {
      this.$emit("close");
    },
  },
});

interface Data {}

interface Methods {
  onClose: () => void;
  onConfirm: () => void;
  onClickOutside: () => void;
}

interface Computed {}

interface Props {
  assistantCat: AssistantCat | null;
  nickname: string;
  isResettingToDefault: boolean;
}
